import { AutoIntegration } from '@givelify/api';
import {
    CLEAR_INTEGRATION,
    ClearIntegration,
    SET_INTEGRATION,
    SetIntegration,
} from './types';

export const setIntegration = (data: AutoIntegration): SetIntegration => {
    return {
        type: SET_INTEGRATION,
        data: {
            ...data,
        } as unknown as AutoIntegration,
    };
};

export const clearIntegration = (): ClearIntegration => {
    return {
        type: CLEAR_INTEGRATION,
    };
};
